const languages = ['pl', 'en', 'ua'];
const defaultLanguage = 'pl';

exports.defaultLanguage = defaultLanguage;
exports.languages = languages;
